<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import { CheckIcon } from '@solar-icons/vue/linear'
import { toOutcomeRows } from '../ChatSurface/chat-outcomes'
import type { AgentOutcome } from '@/types/chat'

const props = defineProps<{
  /** What this reply's tool calls produced, worth a quiet fact or a link under the answer. */
  outcomes: readonly AgentOutcome[]
}>()

const { t } = useI18n()

const rows = computed(() => toOutcomeRows(props.outcomes))
</script>

<template>
  <ul v-if="rows.length" class="flex list-none flex-wrap items-center gap-x-4 gap-y-1">
    <li v-for="(row, i) in rows" :key="`${row.key}-${i}`" class="flex items-center gap-2">
      <CheckIcon class="shrink-0 text-icon-tertiary" />
      <RouterLink
        v-if="row.route"
        :to="row.route"
        class="text-caption text-accent-blue hover:underline"
      >
        {{ t(row.key, row.params ?? {}) }}
      </RouterLink>
      <span v-else class="text-caption text-text-tertiary">{{ t(row.key, row.params ?? {}) }}</span>
    </li>
  </ul>
</template>
